import React from 'react';
import PropTypes from 'prop-types';
import LandscapeImage from './error-landscape.png';
import { URL_SUPPORT } from '../../utils/constants/urls';
import './styles.scss';


const AllErrorMessage = ({ subjectAction, onButtonClick }) => (
  <section className="error-page">
    <div className="content">
      <h2 className="content__title">An Error Occurred</h2>
      <p className="content__description">
        We’re sorry, something went wrong. We were unable to
        {' '}
        {subjectAction} you!
        {' '}
        Please go back and try again.
        If the problem persists, contact FabFitFun Support
        {' '}
        <a href={URL_SUPPORT} target='_blank'>here</a>.
      </p>
      <button type="button" className="content__cta" onClick={onButtonClick}>TRY AGAIN</button>
      <img src={LandscapeImage} alt="landscape" className="content__image" />
    </div>
  </section>
);

AllErrorMessage.defaultProps = {
  subjectAction: 'reactivate',
  onButtonClick: () => null,
};

AllErrorMessage.propTypes = {
  subjectAction: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default AllErrorMessage;
